<template>
  <CardLoaderSmall v-if="isLoading" class="col-span-full flex-1 flex-col" />
  <Box v-else>
    <template #title>Namn på trapphustavla och dörr</template>

    <SectionHeader
      title="Namn på trapphustavla och dörr"
      :editable="canEdit"
      :editing="editable"
      :disabled="editDisabled"
      @edit="$emit('edit')"
      @cancel="cancel"
    />

    <p class="text-b2 mb-4 text-[18px]" v-if="editable">
      Här kan du ändra hur ditt namn visas på trapphustavlan samt din dörr, du kan använda max 27
      tecken.
    </p>

    <p class="text-b2 mb-6 text-[18px]" v-else>
      Här ser du hur ditt namn visas på trapphustavlan samt din dörr.
    </p>

    <div class="w-full md:w-1/2 space-y-4">
      <SelectField
        v-if="contractsData && contractsData.length > 1"
        id="contractNumber"
        label="Kontrakt"
        placeholder=""
        :floatingLabel="true"
        :options="contractsData"
        v-model="selectedContract"
        @change="onSelectedContract"
      />

      <Input
        v-if="selectedContract && editable"
        id="doorName"
        label="Namn på trapphustavla och dörr"
        v-model="localDoorName"
        type="text"
        placeholder="Ditt namn"
        :floatingLabel="true"
        :disabled="!editable"
        maxlength="27"
      />
      <div v-else-if="selectedContract">
        <h4 class="text-b2 mb-2 text-gray-900 font-bold uppercase tracking-wider font-neue-kabel text-[14px] font-thick">Namn på trapphustavla och dörr</h4>
        <p class="text-[18px]">{{localDoorName}}</p>
      </div>

      <Button
        type="submit"
        variant="primary"
        :disabled="initialValue == localDoorName || !editable"
        @click="save"
        size="large"
        v-if="editable"
      >
        Spara ändringar
      </Button>
    </div>
  </Box>
</template>

<script>
import Box from '@/components/ui/box';
import Input from '@/components/ui/form/input';
import Button from '@/components/ui/button';
import { mapGetters } from 'vuex';
import SelectField from '@/components/ui/form/select';
import CardLoaderSmall from '@/components/loader/CardLoaderSmall';
import SectionHeader from '@/components/profile/section-header';

export default {
  name: 'DoorNameSection',
  components: {
    Box,
    Input,
    Button,
    CardLoaderSmall,
    SelectField,
    SectionHeader,
  },
  props: {
    // Om sektionen är i redigeringsläge
    editable: {
      type: Boolean,
      default: true,
    },
    // Om användaren får redigera (visar "Ändra")
    canEdit: {
      type: Boolean,
      default: true,
    },
    // En annan sektion redigeras
    editDisabled: {
      type: Boolean,
      default: false,
    },
    contractNumber: {
      type: Array,
      required: true,
    },
  },
  emits: ['edit', 'cancel', 'save'],
  data() {
    return {
      isLoading: true,
      localDoorName: '',
      selectedContract: null,
      contractsData: null,
      initialValue: '',
      // testAlwaysLoading: true,
    };
  },
  computed: {
    ...mapGetters(['getNamesOnDoorByContractNumber']),
  },

  watch: {
    selectedContract: {
      deep: true,
      handler(contract) {
        if (!contract || !contract.contractNumber) return;

        return this.$store.cache
          .dispatch('fetchNamesOnDoorByContractNumber', contract.contractNumber)
          .then((namesOnDoor) => {
            this.localDoorName = JSON.parse(JSON.stringify(namesOnDoor.NameOnDoor));
            this.initialValue = this.localDoorName;
          })
          .finally(() => {
            this.showLoader = false;
          });
      },
    },
  },

  mounted() {
    if (!this.testAlwaysLoading) {
      new Promise((resolve) => setTimeout(resolve, 500)).then(() => {
        if (this.contractNumber.length == 1) this.selectedContract = this.contractNumber[0];
        else this.contractsData = this.transformContracts(this.contractNumber);
        this.isLoading = false;
      });
    }
  },

  methods: {
    save() {
      const storeData = this.getNamesOnDoorByContractNumber(this.selectedContract.contractNumber);

      this.initialValue = this.localDoorName;
      this.$emit('save', [
        this.localDoorName,
        this.selectedContract.contractNumber,
        storeData?.intercomes,
      ]);
    },

    cancel() {
      this.localDoorName = this.initialValue;
      this.$emit('cancel');
    },

    transformContracts(contracts) {
      return contracts.map((contract) => ({
        ...contract,
        label: contract.rentalObject?.address1 || '', // Move address1 to the root level
        rentalObject: { ...contract.rentalObject }, // Keep rentalObject intact
        value: { ...contract },
      }));
    },

    onSelectedContract(contract) {

    },
  },
};
</script>
